export const tagNameConverter = (tagName: string) => {
  if (tagName === '역대최저가') return '역대최저'
  return tagName
}
